import {TextField, TextFieldProps} from "@mui/material";
import { IMaskInput } from 'react-imask';
import React, {forwardRef, useEffect, useState} from "react";


export type PassportSeriesNumberFieldProps = Omit<TextFieldProps, "onChange"> & {
    onChange?: (v: string) => void
}


function checkValue(value) {
    return /^\d{10}$/.test(value)
}


const FormatInput = forwardRef<HTMLInputElement, {onChange?: (v: string) => void, value?: string}>((props, ref) => {
    const {onChange, value: defaultValue, ...other} = props;
    const [value, setValue] = useState(defaultValue);

    useEffect(() => {
        if (checkValue(defaultValue)) {
            setValue(defaultValue);
        } else if (!defaultValue && checkValue(value)) {
            setValue(defaultValue);
        }
    }, [defaultValue])

    useEffect(() => {
        if (checkValue(value)) {
            onChange(value);
        } else if (defaultValue) {
            onChange(null);
        }
    }, [value]);

    return (
        <IMaskInput
            {...other}
            // @ts-ignore
            value={value}
            // @ts-ignore
            mask="0000 000000"
            // @ts-ignore
            placeholder="0102 345678"
            // @ts-ignore
            inputRef={ref}
            unmask={true}
            onAccept={(value) => {
                // @ts-ignore
                setValue(value);
            }}
            overwrite
        />
    )
})


export const PassportSeriesNumberField = (props: PassportSeriesNumberFieldProps) => {
    return (
        <TextField
            {...props as any}
            InputProps={{
                ...props?.InputProps,
                inputComponent: FormatInput as any
            }}
        />
    )
}